import React from 'react'

export const IconQrCode = (props) => {
  return (
    <svg viewBox="0 0 30 30" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M20 21.25V20H16.25V16.25H20V18.75H22.5V21.25H21.25V23.75H18.75V26.25H16.25V22.5H18.75V21.25H20ZM26.25 26.25H21.25V23.75H23.75V21.25H26.25V26.25ZM3.75 3.75H13.75V13.75H3.75V3.75ZM6.25 6.25V11.25H11.25V6.25H6.25ZM16.25 3.75H26.25V13.75H16.25V3.75ZM18.75 6.25V11.25H23.75V6.25H18.75ZM3.75 16.25H13.75V26.25H3.75V16.25ZM6.25 18.75V23.75H11.25V18.75H6.25ZM22.5 16.25H26.25V18.75H22.5V16.25ZM7.5 7.5H10V10H7.5V7.5ZM7.5 20H10V22.5H7.5V20ZM20 7.5H22.5V10H20V7.5Z" />
    </svg>
  )
}
